module.exports = __webpack_public_path__ + "img/fsg_volleyball.d3b20312.svg";